import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import {
    FormControlLabel,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { TraerListadoSolicitudes } from "../../../actions/compras/Cotizaciones";
import { SolicitudesItem } from "./SolicitudesItem";
const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    },
    tabs: {
        marginTop: "1rem",
    },
    button: {
        textAlign: "center",
    },
});
export const ListadoSolicitudes = (props) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const { estadosSolicitud, solicitudesPendientesCotizacion, idSolicitudCompras, fechaInicioCompras, fechaFinCompras } = useSelector((state) => state.compras);
    const { afiliadoSeleccionado } = useSelector((state) => state.autorizaciones);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(true);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const componentRef = React.useRef();

    useEffect(() => {
        dispatch(TraerListadoSolicitudes(afiliadoSeleccionado?.id_afiliado,
            idSolicitudCompras,
            fechaInicioCompras,
            fechaFinCompras,
            props.idTipoSolicitud));
    }, [estadosSolicitud,
        afiliadoSeleccionado?.id_afiliado,
        idSolicitudCompras,
        fechaInicioCompras,
        fechaFinCompras])

    return (
        <div>
            <Grid>
                <Grid container justify="center" className={classes.root} spacing={1}>
                    <Grid item xs={12}>
                        <Grid>
                            <Paper>
                                <TableContainer component={Paper} style={{ overflowX: "auto" }}>
                                    <Table size={dense ? "small" : "medium"} ref={componentRef}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell>Estado</TableCell>
                                                <TableCell>Fecha Enviada</TableCell>
                                                <TableCell>N° Orden</TableCell>
                                                <TableCell>N° Presupuesto</TableCell>
                                                <TableCell>Tipo Solicitud</TableCell>
                                                <TableCell>Con Internacion</TableCell>
                                                <TableCell>Recupero</TableCell>
                                                <TableCell>Paciente</TableCell>
                                                <TableCell>N° Afiliado</TableCell>
                                                <TableCell>Institución</TableCell>
                                                <TableCell>Profesional</TableCell>
                                                <TableCell>Practicas</TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {solicitudesPendientesCotizacion?.length > 0 ? (
                                                solicitudesPendientesCotizacion
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((item) => (
                                                        <SolicitudesItem
                                                            item={item}
                                                            estadosSolicitud={estadosSolicitud}
                                                            key={item.idSolicitud.toString()}
                                                        />
                                                    ))
                                            ) : (
                                                <TableRow style={{ height: 50 }}>
                                                    <TableCell
                                                        colSpan={13}
                                                        style={{ textAlign: "-webkit-center" }}
                                                    >
                                                        {" "}
                                                        Sin Registros
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>
                        {solicitudesPendientesCotizacion?.length > 0 && (
                            <Grid item xs={12}>
                                <TablePagination
                                    style={{ backgroundColor: "white" }}
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={solicitudesPendientesCotizacion.length}
                                    rowsPerPage={rowsPerPage}
                                    labelRowsPerPage="Registros por página"
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={dense}
                                            onChange={(e) => setDense(e.target.checked)}
                                        />
                                    }
                                    label="Tamaño compacto"
                                />
                            </Grid>
                        )}
                    </Grid>

                </Grid>
            </Grid>
        </div >
    );
}